// extracted by mini-css-extract-plugin
export var errorIcon = "_od-1";
export var nameLogo = "_od-0";